var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box profile-card-2" }, [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          { staticClass: "row investor_list" },
          _vm._l(_vm.form.platform, function (data, i) {
            return _c("div", { key: i, staticClass: "investor_data" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getPlatformNameFromCode(data)) +
                  "\n        "
              ),
            ])
          }),
          0
        ),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "editPlatform",
          tabindex: "-1",
          "aria-labelledby": "editPlatformLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "550px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _c("form", { on: { submit: _vm.updatePlatform } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    staticStyle: { padding: "30px", "padding-top": "50px" },
                  },
                  [
                    _c("div", { staticClass: "form-grouped" }, [
                      _vm.isLoadingPlatforms == true
                        ? _c("div", { staticClass: "list-wrapper" }, [
                            _c("img", {
                              staticClass: "button-spinner",
                              staticStyle: { "margin-left": "10px" },
                              attrs: { src: "/img/lightbox/preloader.gif" },
                            }),
                          ])
                        : _vm._e(),
                      _vm.isLoadingPlatforms == false
                        ? _c(
                            "div",
                            { staticClass: "list-wrapper" },
                            _vm._l(_vm.platformsData, function (item, index) {
                              return _c(
                                "ChipButton",
                                {
                                  key: index,
                                  attrs: {
                                    text: item.name,
                                    dashedBorder: true,
                                    buttonIcon: item.img,
                                    selected: _vm.checkedSelectedItem(item.tag),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSelectIndustry(item.tag)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.img))]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.isUpdateIndustry
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            right: "0",
                            "margin-top": "0%",
                            "text-align": "center",
                          },
                          attrs: { id: "loaderCal" },
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 30,
                              color: "primary",
                              indeterminate: "",
                            },
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s("updating platform...") +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isUpdateIndustry
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-light lightBorder p-3",
                          attrs: { type: "button", "data-bs-dismiss": "modal" },
                        },
                        [_vm._v("\n              Cancel\n            ")]
                      )
                    : _vm._e(),
                  !_vm.isUpdateIndustry
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary p-3",
                          attrs: { type: "submit" },
                        },
                        [_vm._v("\n              Update\n            ")]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "errorModalPlatform",
          tabindex: "-1",
          "aria-labelledby": "errorModalPlatformLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "450px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _c("br"),
                  _c("img", {
                    staticStyle: { "margin-top": "30px", width: "150px" },
                    attrs: { src: "/img/cancel.png" },
                  }),
                  _c("br"),
                  _c("br"),
                  _c("p", { staticStyle: { "margin-top": "30px" } }, [
                    _vm._v(
                      "\n            Error detected while updating industry\n          "
                    ),
                  ]),
                  _c("code", [_vm._v(_vm._s(this.PlatformInfoUpdateError))]),
                  _c("br"),
                  _c("br"),
                ]
              ),
              _vm._m(3),
            ]),
          ]
        ),
      ]
    ),
    _vm._m(4),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6", staticStyle: { "text-align": "left" } },
        [_c("span", { staticClass: "start_up_label" }, [_vm._v("Platform")])]
      ),
      _c(
        "div",
        {
          staticClass: "col-6",
          staticStyle: { "text-align": "right" },
          attrs: {
            "data-bs-toggle": "modal",
            "data-bs-target": "#editPlatform",
          },
        },
        [_c("span", { staticClass: "start_up_edit" }, [_vm._v("Edit")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Edit Platform")]),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("ERROR DETECTED")]),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-light lightBorder",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n            Close\n          ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "successChangeRequestModalPlatform",
          tabindex: "-1",
          "aria-labelledby": "successChangeRequestModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "450px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Industry Updated"),
                ]),
                _c("button", {
                  staticClass: "btn-close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                  },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _c("br"),
                  _c("img", {
                    staticStyle: { "margin-top": "30px", width: "150px" },
                    attrs: { src: "/img/marked.svg" },
                  }),
                  _c("br"),
                  _c("br"),
                  _c("p", { staticStyle: { "margin-top": "30px" } }, [
                    _vm._v("Industry record updated successfully"),
                  ]),
                  _c("br"),
                  _c("br"),
                ]
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light lightBorder",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [_vm._v("\n            Close\n          ")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }